import { ADD_EMPLOYEE } from "../../types";

const INITIAL_STATE = {};

export default function employee(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_EMPLOYEE:
      return Object.assign({}, state, action.employee);
    default:
      return state;
  }
}